<!--
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-08-10 17:18:38
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-11-02 18:16:56
-->
<template>
  <div
    class="data-view-item-wrap ds-control data-view-progress-bar data-view-no-padding"
    @click="clickItem"
    :style="controlStyle"
    v-loading="dataLoad"
    :element-loading-text="loadingText"
    :element-loading-spinner="loadingSpinner"
    :element-loading-background="loadingBackground"
  >
    <div :ref="ref" class="data-view-progress-bar">
      <dsf-empty-data v-if="data === null"></dsf-empty-data>
      <template v-else>
        <template v-if="barType === 'circle'">
          <div class="circle-wrap">
            <svg :width="size" :height="size">
              <defs>
                <linearGradient :id="colorId">
                  <stop offset="0%" :stop-color="viceColor" />
                  <stop offset="100%" :stop-color="mainColor" />
                </linearGradient>
              </defs>
              <circle
                :cx="size / 2"
                :cy="size / 2"
                :r="size / 2 - barWidth / 2"
                :stroke="roundColor"
                :stroke-width="barWidth"
                fill="none"
                stroke-dasharray="0,0"
                stroke-linecap="round"
              ></circle>
              <circle
                id="circle"
                :cx="size / 2"
                :cy="size / 2"
                :r="size / 2 - barWidth / 2"
                :stroke="`url(#${colorId})`"
                :stroke-width="barWidth"
                fill="none"
                :style="circleStyle"
                stroke-linecap="round"
              ></circle>
            </svg>
            <div class="circle-text">
              <slot :data="data">
                <div
                  class="text-title"
                  :style="textStyle"
                  v-html="$textTitle"
                ></div>
                <div
                  class="text-sub-title"
                  :style="subTextStyle"
                  v-html="$textSubTitle"
                ></div>
              </slot>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="line-box">
            <div class="text-title" :style="textStyle">
              <slot>
                <label :style="textStyle" v-html="$textTitle"></label>
                <span :style="subTextStyle" v-html="$textSubTitle"></span>
              </slot>
            </div>
            <div
              class="line-outer"
              :style="`border-radius:${barWidth}px;height:${barWidth}px;background:${roundColor}`"
            >
              <div class="line-inner" :style="lineStyle"></div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
const staticData = ["80"];
export default dsf.component({
  name: "DsfDataViewProgressBar",
  ctrlCaption: "进度条",
  mixins: [$mixins.dataView, $mixins.svg, $mixins.dataAnalysis],
  props: {
    staticData: {
      type: Array,
      default: () => staticData,
    },
    deep: {
      type: [String, Number],
      default: "8",
    },
    barType: {
      type: String,
      default: "circle",
    },
    prop_mainColor: {
      type: String,
      default: "#83bff6",
    },
    prop_viceColor: {
      type: String,
      default: "#00CED1",
    },
    prop_roundColor: {
      type: String,
      default: "#F5F5F5",
    },
    prop_textColor: {
      type: String,
      default: "#FFFFFF",
    },
    prop_subTextColor: {
      type: String,
      default: "#FFFFFF",
    },
    textTitle: {
      type: String,
      default: "人数增长",
    },
    subFontSize: {
      type: String,
      default: "12",
    },
    gap: {
      type: String,
      default: "5",
    },
    textSubTitle: {
      type: String,
      default: "@[value]%",
    },
    excelData: {
      type: Array,
      default: () => {
        return [
          {
            rows: {
              0: {
                cells: {
                  0: { text: "数值", editable: false },
                },
              },
              1: {
                cells: {
                  0: { text: staticData[0] },
                },
              },
            },
          },
        ];
      },
    },
    mapRelations: {
      type: Array,
      default() {
        return [
          {
            text: "值",
            value: "value",
            map: "value",
          },
        ];
      },
    },
  },
  data() {
    let colorId = dsf.uuid();
    return {
      otherEvents: ["刷新", "还原数据", "显示", "隐藏", "替换数据"],
      ref: "progress-bar-wrap",
      componentRef: "progress-bar-wrap",
      data: null,
      originData: [],
      colorId,
    };
  },
  computed: {
    mainColor() {
      return this.getColor(this.prop_mainColor);
    },
    viceColor() {
      return this.getColor(this.prop_viceColor);
    },
    roundColor() {
      return this.getColor(this.prop_roundColor);
    },
    textColor() {
      return this.getColor(this.prop_textColor);
    },
    subTextColor() {
      return this.getColor(this.prop_subTextColor);
    },
    controlStyle() {
      let { padding, height, barType } = this;
      if (barType === "line" && height != "auto") {
        this.$emit("update:height", "auto");
      }
      if (barType === "circle" && height === "auto") {
        this.$emit("update:height", "100%");
      }
      if (this.isDesign) {
        return {
          padding: "8px",
        };
      }

      return {
        padding: padding.join("px ") + "px",
        height,
      };
    },
    $textTitle() {
      let row = this.originData[0] || {};
      return this.$replace(this.textTitle, row);
    },
    $textSubTitle() {
      let row = this.originData[0] || {};
      return this.$replace(this.textSubTitle, row);
    },
    textStyle() {
      return {
        color: this.textColor,
        fontSize: this.transPX(this.fontSize),
      };
    },
    subTextStyle() {
      return {
        color: this.subTextColor,
        fontSize: this.transPX(this.subFontSize),
        marginTop: this.transPX(this.gap),
      };
    },
    barWidth() {
      return this.deep;
    },
    size() {
      const { realWidth: width, realHeight: height } = this;
      return height > width ? width : height;
    },
    circleStyle() {
      let perimeter = 2 * Math.PI * (this.size / 2 - this.barWidth / 2);
      let percent = this.data >= 100 ? 100 : this.data;
      let currentVal = perimeter * (percent / 100);
      return {
        "stroke-dasharray": `${currentVal},${perimeter}`,
      };
    },
    lineStyle() {
      return {
        "border-radius": `${this.barWidth}px`,
        height: `${this.barWidth}px`,
        width: `${this.data}%`,
        "background-image": `linear-gradient(to right, ${this.mainColor} 0%, ${this.viceColor} 100%)`,
      };
    },
  },
  watch: {
    staticData: {
      handler() {
        setTimeout(this.init, 0);
      },
    },
  },

  methods: {
    clickItem() {
      this.$dispatch("clickItem", this.data);
      this.loadClickEvents(this.data);
    },
    dataExcelAnalysis(res) {
      const rows = res[0].rows;
      const data = [];
      Object.keys(rows).forEach((key) => {
        const cells = rows[key].cells;
        if (cells && key != 0) {
          let arr = [];
          Object.keys(cells)
            .slice(0, 1)
            .forEach((_key) => {
              cells[_key].text && arr.push(cells[_key].text);
            });
          arr.length == 1 && data.push(arr[0]);
        }
      });
      this.$dataAnalysis(data);
    },
    dataAnalysis(data) {
      if (!data || !data.length) {
        this.hasData = false;
        return false;
      }
      if (eval(this.dymicRules)) {
        this.data = data.slice(0, 1).map((it) => {
          let val = it[this.mapRelations[0].map];
          return this.handleMapRelationNum(val, this.mapRelations[0]);
        });
        this.originData = data.slice(0, 1).map((it) => {
          let val = it[this.mapRelations[0].map];
          val = this.handleMapRelationNum(val, this.mapRelations[0]);
          return {
            ...it,
            [this.mapRelations[0].map]: val,
          };
        });
      } else {
        this.data = data[0];
        this.originData = [
          {
            value: data[0],
          },
        ];
      }
    },
  },
});
</script>
